var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw-flex tw-flex-col tw-items-start tw-gap-1 tw-text-start"},[_c('h6',{staticClass:"tw-text-xl"},[_vm._v(" "+_vm._s(_vm.question)+" ")]),_c('p',{staticClass:"tw-text-sm !tw-mb-0"},[_vm._v(" "+_vm._s(_vm.info)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }